// extracted by mini-css-extract-plugin
export default {"wrapper":"Description_wrapper__oLS-l","block":"Description_block__RAKmL","value":"Description_value__NX7vg","item":"Description_item__Tvljw","title":"Description_title__NSNiJ"};